/**
 * The path a business's public booking page answers on: `/` and its stored
 * slug, as the API returns it (`organization.slug`).
 *
 * Never rebuilt from the business name. This used to be the name lower-cased
 * with the spaces taken out, which was wrong three ways: the second "Salon Ana"
 * on the platform lives at /salonana-pitesti (or an older /salonana-2), so its
 * owner was shown — and given a widget snippet for — the first one's page; a
 * renamed business kept its slug while the dashboard showed a new address that
 * led nowhere; and punctuation the server drops ("Salon #1") went straight into
 * the link.
 *
 * Empty when there is no slug yet, so a caller can hide a link rather than
 * point it at the site root.
 */
export const publicPagePath = (slug) => (slug ? `/${slug}` : "");
